import { Route, Switch, Redirect, useLocation } from 'react-router-dom'

import { useRoutes } from 'useRoutes.js'

import { useSelector } from 'react-redux'
import NewLogin from 'views/pages/Login'
import NewForgotPassword from 'views/pages/Login/forgotPassword'
import ResetPassword from 'views/pages/Login/resetPassword'
import Signup from 'views/pages/Login/signup'

function Auth() {
  const auth = useSelector((state) => state.auth)
  const location = useLocation()

  const routes = useRoutes()

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (!auth.isAuthenticated) {
        return <Route path='/auth/login' component={NewLogin} key={key} />
      }
      if (prop.collapse) {
        return getRoutes(prop.views)
      }
      if (auth.isAuthenticated && prop.layout === '/auth') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }

  return (
    <div className='h-100'>
      <div className='main-content'>
        <Switch>
          {getRoutes(routes)}
          <Route path='/auth/login' component={NewLogin} />
          <Route path='/auth/signup' component={Signup} />

          <Route path='/auth/forgot-password' component={NewForgotPassword} />
          <Route path='/reset-password' component={ResetPassword} />

          <Redirect from='*' to={`/auth/login${location.search}`} />
        </Switch>
      </div>
    </div>
  )
}

export default Auth
